export default __webpack_public_path__ + "static/media/QK_9306.14340ce1.jpg";